export default class EstudanteValidator {
    constructor() {
    }
}